import { type FormikValues, useFormikContext } from "formik";
import lodashGet from "lodash/get";
import { useMemo, type ComponentPropsWithoutRef } from "react";
import PillarFormInputWrapper, {
  type PillarFormInputWrapperProps,
} from "./PillarFormInputWrapper";

export type PillarFormJSONInputProps = PillarFormInputWrapperProps &
  Omit<
    ComponentPropsWithoutRef<"textarea">,
    "id" | "name" | "value" | "type"
  > & {
    collapse?: boolean;
    initialRows?: number;
  };

const PillarFormJSONInput = ({
  name,
  label,
  labelClassName,
  additionalClasses,
  className,
  onChange,
  collapse = false,
  initialRows = 10,
  testid,
  ...props
}: PillarFormJSONInputProps) => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const rawValue = lodashGet(values, name);

  const displayValue = useMemo(() => {
    if (rawValue === undefined || rawValue === null) {
      return "";
    }
    if (typeof rawValue === "object") {
      return JSON.stringify(rawValue, null, 2);
    }
    return String(rawValue);
  }, [rawValue]);

  return (
    <PillarFormInputWrapper
      name={name}
      labelClassName={labelClassName}
      additionalClasses={`${additionalClasses ?? ""}`}
      label={label}
      collapse={collapse}
    >
      <textarea
        className={`w-full ${className ?? ""}`}
        rows={initialRows}
        id={name}
        value={displayValue}
        data-testid={testid}
        onChange={(e) => {
          setFieldValue(name, e.target.value);
          if (onChange) {
            onChange(e);
          }
        }}
        {...props}
      />
    </PillarFormInputWrapper>
  );
};

export default PillarFormJSONInput;
